import { createContext } from 'react';

export const extractedDataContext = createContext(null);